// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './SignupStep.css';
import Signup from '../common/Signup';

type OwnProps = {
  expanded: boolean,
  onSignupSuccess?: Function,
  fromId: string,
  subheader?: React$Element<typeof FormattedMessage>,
  onClickLoginLink?: Function,
  presetEmail?: string,
};

type Props = OwnProps;

const SignupStep = ({
  expanded,
  fromId,
  subheader,
  onSignupSuccess,
  onClickLoginLink,
  presetEmail,
}: Props) => {
  if (!expanded) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Signup
        onAuthComplete={onSignupSuccess}
        fromId={fromId}
        subheader={subheader}
        onClickLoginLink={onClickLoginLink}
        presetEmail={presetEmail}
      />
    </div>
  );
};

export default SignupStep;
